"use client"
export const dynamic = 'force-dynamic';
import Link from "next/link";
import React, {useState} from "react";

export default function Home() {

  const [email, setEmail] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [securityCode, setSecurityCode] = useState<string>("");


  const [showForgotPassword, setShowForgotPassword] = useState<string>("enterresetemail");


  const handlePasswordResetEmailInput = async () => {

    const options = {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        email: email
      })
    }


    try {

      const response = await fetch("/api/resetpassword", options)
      const json_res = await response.json();


      if (response.status === 200) {
        setShowForgotPassword("setNewPassword");
      };
      alert(json_res.message);



    } catch (err) {
      console.log(err);
      alert("Network Connectivity Issues.");
    }
  }


  const setNewPasswordFunction = async () => {

    const options = {
      method: "PUT",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        email: email,
        newPassword: newPassword,
        securityCode: securityCode
      })
    }


    try {

      const response = await fetch("/api/resetpassword", options)
      const json_res = await response.json();

      if (response.status === 200) {
        window.location.href = "/";
      };
      alert(json_res.message);



    } catch (err) {
      console.log(err);
      alert("Network Connectivity Issues.");
    }
  }

  return (
    <main className="loginmain">
      
      <div className="loginmain-leftimg"></div>

      <div className="loginmain-rightinputs">

        <img src="/logo.png" className="signinlogo" alt="" />

        <p className="large signinheader bold">Recover Password</p>



        <p className="small gray" style={{marginBottom: "8px"}}>Enter your E-Mail to get your password reset code.</p>
        <input type="email" className="textinput logininput" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail"/>
        {showForgotPassword === "enterresetemail" && <button className="orangebutton loginbutton" onClick={handlePasswordResetEmailInput}>Get Reset Code</button>}
      
        

        {showForgotPassword === "setNewPassword" && <p className="small gray" style={{marginBottom: "8px"}}>Enter your password reset code.</p>}
        {showForgotPassword === "setNewPassword" && <input type="text" className="textinput logininput" value={securityCode} onChange={(e) => setSecurityCode(e.target.value)} placeholder="Password Reset Code"/>}

        {showForgotPassword === "setNewPassword" && <p className="small gray" style={{marginBottom: "8px"}}>Enter your new password.</p>}
        {showForgotPassword === "setNewPassword" && <input type="text" className="textinput logininput" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New Password"/>}

        {showForgotPassword === "setNewPassword" && <button className="orangebutton loginbutton" onClick={setNewPasswordFunction}>Set new password.</button>}


        <Link href="/" style={{textDecoration: "none"}}><p className="small blue plink" style={{marginTop: "44px"}} title="Recover Password">Go Back</p></Link>
      </div>

    </main>
  );
}
